'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name initialize
    * @description initializes accessibilty extensions to bootstrap 3 data-toggle="tab"
    **/

    var initialize = function () {

        var tabLists = document.querySelectorAll('[role="tablist"]');
        tabLists.forEach(function (tabList) {
            var tabNavItems = tabList.querySelectorAll('[data-toggle="tab"]');
            tabNavItems.forEach(function (el) {
                el.addEventListener('click', function () {
                    tabNavItems.forEach(function (navItem) {
                        navItem.setAttribute('aria-selected', navItem === el);
                    })
                })
            });
        });
    };

    // Return an object exposing the public items
    return {
        initialize: initialize
    };
}())